import { combineReducers } from "redux";
import { shipment } from "./shipmentReducer";

const shipmentReducer = combineReducers({
  shipment
});

export default shipmentReducer;
